import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  emailVerifyCreateEventModalVar,
  isEmailVerificationSentVar,
  isVerificationToastShowVar,
} from "../../../graphql/globalVar/state";
import { useSendOrganizerVerifyEmailMutation } from "../../../graphql/profiile/profile.hooks";
import { useAuthService } from "../../../services/authService";
import Loading from "../../ui/spinner/Loading";

export default function EmailVerifyCreateEventModal() {
  const { t } = useTranslation();
  const show = useReactiveVar(emailVerifyCreateEventModalVar);
  const isVerificationSent = useReactiveVar(isEmailVerificationSentVar);
  const { email } = useAuthService();
  const [verifyEmail, { loading }] = useSendOrganizerVerifyEmailMutation();

  const handleClose = () => emailVerifyCreateEventModalVar(false);

  const handleVerifyEmail = async () => {
    try {
      await verifyEmail();
      isVerificationToastShowVar(true);
      isEmailVerificationSentVar(true);
      emailVerifyCreateEventModalVar(false);
    } catch {}
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 px-3 pt-3 pb-0">
        <Modal.Title className="fw-bold fs-5">
          {t("emailVerify.modal.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3 text-center">
        <p className="text-dark fs-6 mb-3">{t("emailVerify.modal.body")}</p>
        <p className="text-dark fs-6 mb-0">
          {t("emailVerify.modal.emailHint", { email })}
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 p-2 pt-0">
        <Button
          variant="success"
          className="w-100 rounded-3 py-3 text-white fw-bold"
          disabled={loading || isVerificationSent}
          onClick={handleVerifyEmail}
        >
          {loading ? <Loading size="sm" /> : t("emailVerify.modal.verify")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
